module.exports = __webpack_public_path__ + "img/caret-gery-down.2b66290d.svg";